import { Callout, Text, Icon, Separator } from '@scale/scaleui-radix';
import { faCheckCircle, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import {
  CompassTransformScript,
  CompassTransformScriptMetadata,
} from '@scale/genai-compass-shared/cards/transform_script';
import type { Column } from '@scale/compass-shared/types';
import ScriptParamsComponent from './ScriptParamsComponent';

interface SelectedScriptCalloutProps {
  localScript?: CompassTransformScript;
  scriptParams?: Record<string, any>;
  onScriptParamsChange?: (params: Record<string, any>) => void;
  columns?: Column[];
}

const SelectedScriptCallout = ({
  localScript,
  scriptParams = {},
  onScriptParamsChange,
  columns,
}: SelectedScriptCalloutProps) => {
  if (localScript) {
    return (
      <Callout.Root color="accent" className="mt-4">
        <div className="flex flex-col w-full">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-2">
              <Icon
                icon={faCheckCircle}
                label="Selected"
                className="text-primary-500"
                data-testid="selected-script-icon"
              />
              <Callout.Text>
                <Text as="span" size="2" className="font-semibold">
                  {CompassTransformScriptMetadata[localScript].name}
                </Text>
                <Text as="span" size="2" className="ml-1">
                  script selected
                </Text>
              </Callout.Text>
            </div>
          </div>

          {onScriptParamsChange && (
            <>
              <Separator className="my-3" />

              <div className="p-2">
                <ScriptParamsComponent
                  script={localScript}
                  params={scriptParams}
                  onChange={onScriptParamsChange}
                  columns={columns}
                />
              </div>
            </>
          )}
        </div>
      </Callout.Root>
    );
  }

  return (
    <Callout.Root color="neutral" className="mt-4">
      <Callout.Icon>
        <Icon icon={faCircleInfo} label="Info" />
      </Callout.Icon>
      <Callout.Text>Select a script to use the transform script card</Callout.Text>
    </Callout.Root>
  );
};

export default SelectedScriptCallout;
